import DevelopmentStageBadge from './DevelopmentStageBadge';
import { STAGE_COLORS, PROFILE_COLORS, PROFILE_TYPOGRAPHY, PROFILE_RADIUS } from './constants';
import type { DevelopmentalStage } from '../../types/assessment.types';

import rightChevron from '../../../assets/icons/skill-card-chevron.svg';

export type CategoryCardState =
  | { type: 'completed'; stage: DevelopmentalStage }
  | { type: 'notAssessed' }
  | { type: 'needsReassessment'; stage: DevelopmentalStage };

interface CategoryCardProps {
  categoryName: string;
  description: string;
  state: CategoryCardState;
  onClick: () => void;
}

export default function CategoryCard({
  categoryName,
  description,
  state,
  onClick,
}: CategoryCardProps) {
  const isCompleted = state.type === 'completed';
  const isNotAssessed = state.type === 'notAssessed';
  const stageKey = isCompleted ? state.stage : null;
  const stageColors = stageKey ? STAGE_COLORS[stageKey] : STAGE_COLORS.notAssessed;

  return (
    <button
      onClick={onClick}
      className="w-full text-left flex flex-col gap-2 p-4 transition-opacity hover:opacity-90"
      style={{
        backgroundColor: stageColors.cardBg,
        borderRadius: `${PROFILE_RADIUS.categoryCard}px`,
      }}
    >
      {/* Top row: badge + chevron */}
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2">
          {isCompleted && <DevelopmentStageBadge stage={state.stage} />}
          {state.type === 'needsReassessment' && (
            <>
              <DevelopmentStageBadge stage={state.stage} muted />
              <span
                className="text-xs font-medium"
                style={{ color: PROFILE_COLORS.textMuted }}
              >
                Ready for an update
              </span>
            </>
          )}
          {isNotAssessed && (
            <>
              <DevelopmentStageBadge stage={'notAssessed'} muted />
              <span
                className={`${PROFILE_TYPOGRAPHY.badgeLabel.weight} ${PROFILE_TYPOGRAPHY.badgeLabel.sizeClasses} ${PROFILE_TYPOGRAPHY.badgeLabel.extra}`}
                style={{ color: PROFILE_COLORS.textMuted }}
              >
                Begin check-in
              </span>
            </>
          )}
        </div>
        {/* Chevron arrow */}
        <img
          src={rightChevron}
          alt="Go to category"
        //className="w-full"
        />
      </div>

      {/* Category name */}
      <span
        className={`${PROFILE_TYPOGRAPHY.categoryName.weight} ${PROFILE_TYPOGRAPHY.categoryName.sizeClasses}`}
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: PROFILE_COLORS.textPrimary,
        }}
      >
        {categoryName}
      </span>

      {/* Description */}
      <span
        className={`${PROFILE_TYPOGRAPHY.categoryDescription.weight} ${PROFILE_TYPOGRAPHY.categoryDescription.sizeClasses}`}
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: stageColors.text,
        }}
      >
        {description}
      </span>
    </button>
  );
}
